import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";

import { NgIconComponent, provideIcons } from "@ng-icons/core";
import { iconoirCancel } from "@ng-icons/iconoir";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "app-alert",
  standalone: true,
  imports: [CommonModule, NgIconComponent, ButtonModule],
  providers: [provideIcons({ iconoirCancel })],
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.scss"],
})
export class AlertComponent {
  @Output() whenClosed = new EventEmitter<boolean>();

  @Input() closable = false;
  @Input() styleClass = "";
  @Input() type: "success" | "warning" | "error" | "info" = "info";
}
